import React, { useRef, useState, useLayoutEffect } from "react";
import CustomProduct from "./CustomProduct";
import { connect } from "react-redux";
import { serverResponse } from "../../util/fakeServer";
import { BREAKPOINT, H_COMPONENTS } from "../../helper/constant";
import { isMobileSafari } from "react-device-detect";
import ReactDOM from "react-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import Loader from "../common/Loader";
import { animationType, getCustomActions } from "../../helper/utility";
import { isPrefetched, markPrefetched } from "../../helper/imagePrefetch";
import useCurrentWidth from "../../hooks/widthHook";

const CustomSlide = (props) => {
  // Loader event-driven (niente polling 300ms).
  // - Cache hit: useLayoutEffect rileva img.complete=true e lascia loader off.
  //   Zero frame di loader visibile.
  // - Cache miss: useLayoutEffect attiva loader; afterLoad/onError lo spengono.
  const [loadingImages, setLoadingImages] = useState(false);
  const width = useCurrentWidth();

  const listProducts = props.products.map((element, key) => {
    return (
      !!element.blueprint && (
        <CustomProduct
          pageNumber={props.pageNumber}
          zoom={props.zoom}
          disableSwipe={props.disableSwipe}
          enableSwipe={props.enableSwipe}
          key={key}
          blueprint={element.blueprint}
          info={getCustomActions().getInteractivity(element.item_id)}
          leafletSwipe={props.leafletSwipe}
          isSwipeDisabed={props.isSwipeDisabed}
          setSwipe={props.setSwipe}
          dynamic_price={element.dynamic_price}
          dynamic_info={element.dynamic_info}
          show_dynamic_price={element.show_dynamic_price}
          dynamic_price_position={element.dynamic_price_position}
        />
      )
    );
  });

  const imageRef = useRef(null);

  // Detection a mount: 3 modi per decidere se mostrare il loader.
  //   1) isPrefetched(url)=true → il nostro helper ha già scaricato con
  //      successo questo URL (`new Image()` è completato). Anche se il
  //      nuovo <img> nel DOM non è ancora `complete` (lookup HTTP cache è
  //      async), sappiamo che è in HTTP cache → niente loader. Fix per il
  //      back-navigation: AwesomeSlider rimonta i CustomSlide e img.complete
  //      è false al primo useLayoutEffect, ma il file è già scaricato.
  //   2) img.complete = true → fallback nativo browser
  //   3) Altrimenti loader on, attendiamo afterLoad/onLoad/onError
  useLayoutEffect(() => {
    const fullUrl = props.imagePath + "?v=" + serverResponse.config.version;

    if (isPrefetched(fullUrl)) {
      return;
    }

    const el = ReactDOM.findDOMNode(imageRef.current);
    if (!el) {
      setLoadingImages(true);
      return;
    }
    const img = el.tagName === "IMG" ? el : el.querySelector("img");
    if (img && (img.complete || img.naturalWidth > 0)) {
      // Cache hit nativo (es. HEAD preload del <link>). Lo marchiamo nel
      // helper così future re-mount lo riconoscono via isPrefetched.
      markPrefetched(fullUrl);
      return;
    }
    setLoadingImages(true);
  }, [props.imagePath, props.pageNumber]);

  // Sia LazyLoadImage.afterLoad che il passthrough onLoad sull'<img>
  // sottostante chiamano handleImageReady. Dedup col ref per evitare log e
  // setState doppi.
  const readyRef = useRef(false);
  const handleImageReady = () => {
    if (readyRef.current) return;
    readyRef.current = true;
    const fullUrl = props.imagePath + "?v=" + serverResponse.config.version;
    // Marca anche qui: il <img> ha caricato → quasi certamente in HTTP cache
    // → le re-mount successive (back/forward nav) trovano isPrefetched=true.
    markPrefetched(fullUrl);
    setLoadingImages(false);
  };

  const safariDetectMobile = isMobileSafari ? 30 : 0;

  return (
    <div
      id={`slide_${props.pageNumber}`}
      className={`${
        serverResponse.config.scrollVertical && width < BREAKPOINT.xs
          ? "mt-2 mb-2 d-flex p-0 flex-column justify-content-center align-items-center bordo productCostomPosition"
          : `d-flex p-0 flex-column justify-content-center align-items-center bordo ${
              width > BREAKPOINT.xs && "productCostomPosition"
            }`
      } `}
    >
      {loadingImages && <Loader single={props.single} />}
      <div
        className={`${animationType(props.animationType)}`}
        style={{ position: "relative" }}
      >
        <div className={`shadow-${props.shadow}`}></div>

        <LazyLoadImage
          ref={imageRef}
          alt=""
          src={props.imagePath + "?v=" + serverResponse.config.version}
          placeholderSrc={
            props.imageThumbPath + "?v=" + serverResponse.config.version
          }
          visibleByDefault={true}
          afterLoad={handleImageReady}
          onLoad={handleImageReady}
          onError={handleImageReady}
          className={`img-fluid`}
          style={{
            maxHeight:
              width < BREAKPOINT.xs && serverResponse.config.scrollVertical
                ? "unset"
                : `calc(100vh - ${
                    H_COMPONENTS.header +
                    H_COMPONENTS.pager +
                    (width < BREAKPOINT.xs ? H_COMPONENTS.bottomTab : 0) +
                    safariDetectMobile
                  }px)`,
          }}
        />
        <div className="productCostomPositionInner">{listProducts}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    carouselIndex: state.carousel,
  };
};

export default connect(mapStateToProps)(CustomSlide);
